import React from 'react';
import { getCardDisplay } from '../utils/gameLogic';

const Card = ({ card, hidden = false, small = false, mobile = false }) => {
  // Responsive sizing
  const sizeClasses = mobile 
    ? 'w-12 h-16 md:w-16 md:h-24' 
    : small 
      ? 'w-12 h-16 md:w-14 md:h-20' 
      : 'w-14 h-20 md:w-[70px] md:h-[98px]';
  
  if (hidden || !card) {
    return (
      <div 
        className={`${sizeClasses} rounded-lg flex items-center justify-center relative overflow-hidden transform transition-all duration-300`}
        style={{ 
          background: 'linear-gradient(145deg, #8B0000, #4a0000)',
          border: '2px md:border-[3px] solid #ffd700',
          boxShadow: '0 4px 8px rgba(0,0,0,0.4), inset 0 1px 2px rgba(255,215,0,0.3)'
        }}
      >
        {/* Elegant card back pattern */}
        <div className="absolute inset-1 md:inset-2 rounded overflow-hidden" style={{
          border: '1px solid rgba(255,215,0,0.4)',
          background: 'repeating-linear-gradient(45deg, transparent, transparent 3px, rgba(255,215,0,0.1) 3px, rgba(255,215,0,0.1) 6px)'
        }}>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-lg md:text-2xl" style={{ color: '#ffd700', opacity: 0.6 }}>♠</div>
          </div>
        </div>
      </div>
    );
  }

  const { value, suit, isRed } = getCardDisplay(card);

  return (
    <div 
      className={`${sizeClasses} rounded-lg flex flex-col items-center justify-center relative transform transition-all duration-300`}
      style={{ 
        background: 'linear-gradient(145deg, #ffffff, #e8e8e8)',
        border: '1px md:border-2 solid #ccc',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
      }}
    >
      {/* Top left corner - hidden on very small screens */}
      <div className={`absolute top-0.5 left-1 text-[8px] md:text-xs font-bold hidden md:block ${isRed ? 'text-red-600' : 'text-gray-900'}`}>
        {value}
        <div className="text-[10px] md:text-sm -mt-0.5">{suit}</div>
      </div>
      
      {/* Center suit */}
      <div className={`text-2xl md:text-4xl ${isRed ? 'text-red-600' : 'text-gray-900'}`}>
        {suit}
      </div>
      <div className={`text-sm md:text-lg font-bold md:hidden ${isRed ? 'text-red-600' : 'text-gray-900'}`}>
        {value}
      </div>
      
      {/* Bottom right corner - hidden on mobile */}
      <div className={`absolute bottom-0.5 right-1 text-[8px] md:text-xs font-bold rotate-180 hidden md:block ${isRed ? 'text-red-600' : 'text-gray-900'}`}>
        {value}
        <div className="text-[10px] md:text-sm -mt-0.5">{suit}</div>
      </div>
    </div>
  );
};

export default Card;
